module.exports = __webpack_public_path__ + "img/FGT_Logo_Horizontal_Tagline.08b3afbb.png";